import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { SystemInfoService } from 'app/core/services/system-info/system-info-service.service';
import * as SystemInfoActions from './system-info.actions';

@Injectable()
export class SystemInfoEffects {
  constructor(
    private actions$: Actions,
    private systemInfoService: SystemInfoService
  ) {}

  loadSystemInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SystemInfoActions.loadSystemInfo),
      exhaustMap(() =>
        this.systemInfoService.getSystemInfos().pipe(
          map(systemInfo => SystemInfoActions.loadSystemInfoSuccess({ systemInfo })),
          catchError(() => of(SystemInfoActions.loadSystemInfoError()))
        )
      )
    )
  );
}
